<div class="wrapper" #wrapper>
    <tyl-form-field 
    [floatLabel]='floatLabel' 
    [hideRequiredMarker]="hideRequiredMarker"
    [hintLabel]="hintLabel"
    [hintColor]="hintColor"
    [clearable]="clearable"
    [preventCollapse]="preventCollapse"
    [required]="required"
    [postLabelSpace]="postLabelSpace"
    [label]="label"
    [ngClass]="{'showButton': showButton}"
    class="dataDefDropdown">
    <mat-select 
        #control 
        [(ngModel)]='_value' 
        (selectionChange)="valueChangeHandler()" 
        [required]='required' 
        [disabled]="disabled">
        <mat-option [value]="" *ngIf="!required"></mat-option>
        <mat-option *ngFor='let opt of options' [value]='useCodeAsValue ? opt.Code : opt.Id'>{{(dataDef.CodeNotRequired ? '' : (opt.Code ? opt.Code : '') + ' - ') + (opt.Description ? opt.Description : '')}}</mat-option>
    </mat-select>
</tyl-form-field>
<data-def-button [dataDefEnum]="dataDefEnum" (dataDefUpdated)="getDataDef()" [disabled]="disabled" *ngIf="showButton"></data-def-button>
</div>